// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["query AcademyBogImagesQuery  {\nbog_user_backgrounds  {\n__typename  \nimage  {\n__typename  \nlocationIndex  \nexpandedImageSrc  \n}\n\n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.bog_user_backgrounds;
  return {
          bog_user_backgrounds: value$1.map(function (value) {
                var value$1 = value.image;
                return {
                        __typename: value.__typename,
                        image: {
                          __typename: value$1.__typename,
                          locationIndex: value$1.locationIndex,
                          expandedImageSrc: value$1.expandedImageSrc
                        }
                      };
              })
        };
}

function serialize(value) {
  var value$1 = value.bog_user_backgrounds;
  var bog_user_backgrounds = value$1.map(function (value) {
        var value$1 = value.image;
        var value$2 = value$1.expandedImageSrc;
        var value$3 = value$1.locationIndex;
        var value$4 = value$1.__typename;
        var image = {
          __typename: value$4,
          locationIndex: value$3,
          expandedImageSrc: value$2
        };
        var value$5 = value.__typename;
        return {
                __typename: value$5,
                image: image
              };
      });
  return {
          bog_user_backgrounds: bog_user_backgrounds
        };
}

function serializeVariables() {
  
}

function makeVariables() {
  
}

function makeDefaultVariables() {
  
}

var AcademyBogImages_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var AcademyBogImages = {
  AcademyBogImages_inner: AcademyBogImages_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  use: use,
  useFetch: useFetch
};

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function use$1() {
  var getBackgound = Q.useAsync();
  var match = React.useState(function () {
        return "LoadingBg";
      });
  var setBackground = match[1];
  React.useEffect((function () {
          var run = async function () {
            var bg = await getBackgound();
            if (bg !== undefined) {
              var match = bg.bog_user_backgrounds;
              if (match.length === 1) {
                var match$1 = match[0];
                var expandedImageSrc = match$1.image.expandedImageSrc;
                return setBackground(function (param) {
                            return {
                                    TAG: "Bg",
                                    _0: expandedImageSrc
                                  };
                          });
              }
              
            }
            return setBackground(function (param) {
                        return "NoBgSet";
                      });
          };
          run();
        }), []);
  return match[0];
}

export {
  AcademyBogImages ,
  Q ,
  use$1 as use,
}
/* query Not a pure module */
